import { ResidencePermit } from '@axo/shared/data-access/types';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import {
  ApplicationConditionalContext,
  useApplicationConditionalContext,
} from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { useConditionalFilter } from '../../../../ConditionalWrappers/useConditionalFilter';
import { useFormContext } from 'react-hook-form';
import { ApplicationDataFormValues } from '../../../ApplicationDataForm/ApplicationDataFormSchema';
import { MarketCountryCode } from '@axo/shared/types';

interface ConditionalResidencePermitTypeContext
  extends ApplicationConditionalContext {
  residencePermit?: ResidencePermit;
}

const unfilteredResidencePermitTypeOptions = (
  [
    { value: null },

    ...['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'R', 'Z'].map(
      (code) => ({
        value: code,
        whitelist: [
          {
            residencePermit: [ResidencePermit.Temporary],
            marketCountry: [MarketCountryCode.Denmark],
          },
        ],
      }),
    ),
    ...['B', 'D', 'H', 'L'].map((code) => ({
      value: code,
      whitelist: [
        {
          residencePermit: [ResidencePermit.Permanent],
          marketCountry: [MarketCountryCode.Denmark],
        },
      ],
    })),
  ] satisfies UnfilteredConditionalArray<
    ConditionalResidencePermitTypeContext,
    string | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useResidencePermitTypeOptions = (
  coApplicantCustomerID: string | undefined,
) => {
  const residencePermitFieldName:
    | 'ResidencePermit'
    | 'CoApplicantResidencePermit' = coApplicantCustomerID
    ? 'CoApplicantResidencePermit'
    : 'ResidencePermit';

  const { watch } = useFormContext<ApplicationDataFormValues>();
  const [residencePermit] = watch([residencePermitFieldName]);

  const applicationConditionalContext = useApplicationConditionalContext();
  const ctx: ConditionalResidencePermitTypeContext = {
    ...applicationConditionalContext,
    residencePermit: residencePermit ?? undefined,
  };

  return useConditionalFilter(ctx, unfilteredResidencePermitTypeOptions);
};
